import React from 'react';
import { styled } from '@mui/material/styles';
import { Button, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const PREFIX = 'ConfirmationFailed';

const classes = {
  root: `${PREFIX}-root`,
  content: `${PREFIX}-content`,
  contentBody: `${PREFIX}-contentBody`,
  form: `${PREFIX}-form`,
  title: `${PREFIX}-title`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    height: '100%',
  },

  [`& .${classes.content}`]: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },

  [`& .${classes.contentBody}`]: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  [`& .${classes.form}`]: {
    width: '600px',
    backgroundColor: 'white',
    borderRadius: '8px',
    padding: '30px',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },

  [`& .${classes.title}`]: {
    textAlign: 'center',
    paddingBottom: '20px',
  },
}));

const ConfirmationFailed = props => {
  return (
    <Root className={classes.root}>
      <div className={classes.content}>
        <div className={classes.contentBody}>
          <div className={classes.form}>
            <Typography className={classes.title} variant='h2'>
              Подтверждение не выполнено.
            </Typography>
            <Typography>Ссылка не валидна. Ссылка уже подтверждена или устарела.</Typography>
            <Button
              color='primary'
              variant='contained'
              component={RouterLink}
              to='/sign-in'
              size='large'
              sx={{ mt: 2 }}
            >
              Войти
            </Button>
          </div>
        </div>
      </div>
    </Root>
  );
};

export default ConfirmationFailed;
